export enum EBuyerInvoiceStatus {
  PENDING = 'PDNG',
  ACPT = 'ACPT',
  REJECT = 'RJCT',
}

export enum EBuyerBillingStatus {
  PENDING = 'OK',
  ACPT = 'ACPT',
  REJECT = 'RJCT',
}

export enum EBuyerPaymentStatus {
  PREPARE = '',
  PDNG = 'OK',
  PACC = 'PACC',
  ACCC = 'ACCC',
  CXLD = 'CXLD',
  ERR = 'ERR',
}
